var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageBotResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 180,
    viewBox: "0 0 240 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4385_14334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.84 89.0456C224.66 73.7888 210.782 61.2713 194.744 59.7501C179.604 58.3131 164.991 66.1829 149.783 66.3232C125.193 66.5477 104.783 47.0361 80.6925 42.0964C52.6959 36.354 21.798 53.7495 12.1852 80.6763C5.9787 98.0605 9.15491 117.999 18.9978 133.519H225.412C232.438 119.885 234.755 103.545 229.834 89.0512L229.84 89.0456Z",
    fill: "url(#paint0_linear_4385_14334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.125 14.0734C216.125 13.4279 215.974 12.7936 215.688 12.2154C215.401 11.6372 214.98 11.1377 214.47 10.7503C213.953 10.363 213.359 10.0992 212.725 9.98695C212.09 9.86907 211.439 9.90275 210.822 10.0824C210.429 8.62293 209.543 7.34872 208.308 6.47866C207.074 5.60861 205.575 5.19884 204.071 5.31672C202.567 5.4346 201.153 6.08012 200.07 7.1298C198.993 8.18509 198.314 9.58279 198.157 11.0815C197.573 10.8682 196.956 10.7896 196.338 10.8458C195.721 10.9019 195.126 11.0984 194.599 11.4183C194.071 11.7383 193.617 12.1705 193.274 12.6869C192.932 13.2033 192.713 13.7927 192.629 14.4046V14.4551C192.629 14.4888 192.612 14.5674 192.607 14.6235C192.607 14.6796 192.59 14.8424 192.59 14.9827C192.59 15.5272 192.696 16.0661 192.904 16.5713C193.112 17.0765 193.42 17.5312 193.808 17.9185C194.195 18.3058 194.649 18.6089 195.154 18.8166C195.659 19.0243 196.198 19.1309 196.742 19.1253H211.664C212.315 19.1253 212.96 18.9794 213.544 18.6931C214.127 18.4068 214.644 17.9914 215.042 17.475C215.732 16.5713 216.338 15.3644 216.125 14.0566V14.0734Z",
    fill: "url(#paint1_linear_4385_14334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3608 12.9229C51.3608 11.9743 51.142 11.0368 50.7211 10.1836C50.3002 9.33603 49.6829 8.59508 48.9198 8.02253C48.1622 7.44998 47.2811 7.06828 46.344 6.89988C45.4125 6.73148 44.4473 6.782 43.5382 7.04582C42.9602 4.89595 41.6526 3.02112 39.8345 1.7413C38.0163 0.461478 35.8109 -0.144755 33.5943 0.0292557C31.3777 0.20888 29.2957 1.15191 27.7076 2.70678C26.1195 4.26165 25.1206 6.32171 24.8962 8.53333C24.0432 8.21899 23.1229 8.10112 22.2194 8.18532C21.3103 8.26952 20.4349 8.5614 19.6549 9.0273C18.8748 9.49882 18.2071 10.1387 17.7076 10.8965C17.2082 11.6599 16.8827 12.5244 16.7592 13.4281V13.5067C16.7592 13.5572 16.7368 13.6751 16.7312 13.7593C16.7144 13.894 16.7087 14.0736 16.7031 14.2869C16.7031 15.0896 16.8603 15.8867 17.1689 16.6276C17.4775 17.3686 17.9265 18.0422 18.4933 18.6091C19.06 19.1761 19.739 19.6251 20.4798 19.9282C21.2205 20.2314 22.0174 20.3885 22.8199 20.3829H44.7952C45.7548 20.3829 46.7031 20.164 47.5617 19.743C48.4259 19.322 49.1779 18.7102 49.7671 17.9524C50.7884 16.6164 51.6863 14.837 51.3608 12.9061V12.9229Z",
    fill: "url(#paint2_linear_4385_14334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3692 97.5752C32.3692 96.9465 31.8642 96.4413 31.2357 96.4413C30.6072 96.4413 30.1021 96.9465 30.1021 97.5752V102.139C30.1021 102.767 30.6072 103.273 31.2357 103.273C31.8642 103.273 32.3692 102.767 32.3692 102.139V97.5752ZM31.2413 97.7548C35.8485 97.7548 39.5802 94.022 39.5802 89.4136C39.5802 84.8051 35.8485 81.0723 31.2413 81.0723C26.6341 81.0723 22.9023 84.8051 22.9023 89.4136C22.9023 94.022 26.6341 97.7548 31.2413 97.7548Z",
    fill: "url(#paint3_linear_4385_14334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.375 130.731C83.375 135.733 87.4322 139.791 92.4322 139.791H182.011C187.011 139.791 191.069 135.733 191.069 130.731V27.0488H83.375V130.731Z",
    fill: "url(#paint4_linear_4385_14334)",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.011 14.8906H92.4322C87.4322 14.8906 83.375 18.949 83.375 23.9504V27.0433H191.069V23.9504C191.069 18.949 187.011 14.8906 182.011 14.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.451 100.452H111.879C111.447 100.452 111.099 100.104 111.099 99.6722V92.8184C111.099 92.3862 111.447 92.0381 111.879 92.0381H178.451C178.883 92.0381 179.231 92.3862 179.231 92.8184V99.6722C179.231 100.104 178.883 100.452 178.451 100.452ZM134.309 90.8369V87.6486C134.309 87.4802 134.175 87.3398 134.001 87.3398H111.402C111.234 87.3398 111.094 87.4746 111.094 87.6486V90.8369C111.094 91.0053 111.228 91.1456 111.402 91.1456H134.001C134.169 91.1456 134.309 91.0109 134.309 90.8369ZM101.099 87.7328C97.8445 87.7328 95.207 90.371 95.207 93.6267C95.207 96.8824 97.8445 99.5206 101.099 99.5206C104.354 99.5206 106.992 96.8824 106.992 93.6267C106.992 90.371 104.354 87.7328 101.099 87.7328Z",
    fill: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.451 79.6223H111.879C111.447 79.6223 111.099 79.2743 111.099 78.8421V71.9883C111.099 71.5561 111.447 71.2081 111.879 71.2081H178.451C178.883 71.2081 179.231 71.5561 179.231 71.9883V78.8421C179.231 79.2743 178.883 79.6223 178.451 79.6223ZM134.309 70.0068V66.8185C134.309 66.6501 134.175 66.5098 134.001 66.5098H111.402C111.234 66.5098 111.094 66.6445 111.094 66.8185V70.0068C111.094 70.1752 111.228 70.3156 111.402 70.3156H134.001C134.169 70.3156 134.309 70.1808 134.309 70.0068ZM101.099 66.9027C97.8445 66.9027 95.207 69.5409 95.207 72.7966C95.207 76.0523 97.8445 78.6905 101.099 78.6905C104.354 78.6905 106.992 76.0523 106.992 72.7966C106.992 69.5409 104.354 66.9027 101.099 66.9027Z",
    fill: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.451 120.597H111.879C111.447 120.597 111.099 120.249 111.099 119.817V112.963C111.099 112.531 111.447 112.183 111.879 112.183H178.451C178.883 112.183 179.231 112.531 179.231 112.963V119.817C179.231 120.249 178.883 120.597 178.451 120.597ZM134.309 110.981V107.793C134.309 107.625 134.175 107.484 134.001 107.484H111.402C111.234 107.484 111.094 107.619 111.094 107.793V110.981C111.094 111.15 111.228 111.29 111.402 111.29H134.001C134.169 111.29 134.309 111.155 134.309 110.981ZM101.099 107.877C97.8445 107.877 95.207 110.516 95.207 113.771C95.207 117.027 97.8445 119.665 101.099 119.665C104.354 119.665 106.992 117.027 106.992 113.771C106.992 110.516 104.354 107.877 101.099 107.877Z",
    fill: "#EFF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.424 48.1855H96.0112C95.5649 48.1855 95.2031 48.5474 95.2031 48.9939V55.7971C95.2031 56.2435 95.5649 56.6054 96.0112 56.6054H178.424C178.871 56.6054 179.232 56.2435 179.232 55.7971V48.9939C179.232 48.5474 178.871 48.1855 178.424 48.1855Z",
    fill: "#BBE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.424 36.6641H96.0112C95.5649 36.6641 95.2031 37.0259 95.2031 37.4724V44.2756C95.2031 44.722 95.5649 45.0839 96.0112 45.0839H178.424C178.871 45.0839 179.232 44.722 179.232 44.2756V37.4724C179.232 37.0259 178.871 36.6641 178.424 36.6641Z",
    fill: "#BBE6FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4385_14334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6934 15.4078L40.7673 19.6064C38.6529 20.2028 37.4081 22.4214 38.0037 24.5386L39.7608 30.8008C40.3564 32.918 42.572 34.1644 44.6865 33.568L48.2959 32.5542C50.4579 33.6873 51.8457 34.7728 52.4413 34.6058C53.0191 34.4447 53.7576 32.5363 54.9131 30.6934L59.6125 29.3694C61.7269 28.773 62.9717 26.5544 62.3761 24.4372L60.6191 18.1751C60.0235 16.0579 57.8078 14.8114 55.6934 15.4078Z",
    fill: "url(#paint5_linear_4385_14334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.383 20.4615L48.7022 26.825L46.6652 25.6502C46.2423 25.4056 45.7062 25.5488 45.462 25.9722C45.2178 26.3956 45.3608 26.9324 45.7837 27.1769L48.583 28.7991C49.0059 29.0436 49.542 28.9005 49.7862 28.4771L53.9078 21.3442C54.152 20.9207 54.009 20.384 53.5921 20.1395C53.1692 19.889 52.6272 20.0321 52.383 20.4556V20.4615Z",
    fill: "#FBFBFB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4385_14334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7285 45.9999L57.0987 39.0997C53.3285 38.1216 49.4392 40.4117 48.4683 44.1929L45.5856 55.3633C44.6088 59.1385 46.8959 63.033 50.6721 64.0051L57.1107 65.675C59.4157 69.3428 60.5771 72.2532 61.6373 72.5276C62.6737 72.7959 65.5028 70.5237 68.9097 68.7345L77.2959 70.9054C81.0661 71.8835 84.9555 69.5933 85.9263 65.8122L88.8091 54.6417C89.7859 50.8665 87.4987 46.9721 83.7226 45.9999H83.7285Z",
    fill: "url(#paint6_linear_4385_14334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1283 50.6211L62.9486 57.3067L60.8044 53.7343C60.3637 52.9948 59.4048 52.7562 58.6662 53.1975C57.9276 53.6389 57.6834 54.5991 58.1242 55.3446L61.0606 60.2708C61.5013 61.0103 62.4602 61.2548 63.2048 60.8135L75.7305 53.3228C76.469 52.8814 76.7132 51.9213 76.2725 51.1817C75.8317 50.4303 74.8728 50.1857 74.1283 50.6271V50.6211Z",
    fill: "#FBFBFB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4385_14334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.776 79.3292H49.0536C46.4747 79.3292 44.384 81.4226 44.384 84.005V104.974C44.384 107.557 46.4747 109.65 49.0536 109.65H166.776C169.355 109.65 171.446 107.557 171.446 104.974V84.005C171.446 81.4226 169.355 79.3292 166.776 79.3292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.776 112.894H49.0536C46.4747 112.894 44.384 114.988 44.384 117.57V138.539C44.384 141.121 46.4747 143.215 49.0536 143.215H166.776C169.355 143.215 171.446 141.121 171.446 138.539V117.57C171.446 114.988 169.355 112.894 166.776 112.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.55 123.082H76.0944C75.578 123.082 75.1593 123.502 75.1593 124.019V132.094C75.1593 132.611 75.578 133.03 76.0944 133.03H156.55C157.066 133.03 157.485 132.611 157.485 132.094V124.019C157.485 123.502 157.066 123.082 156.55 123.082Z",
    fill: "#BBE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8348 133.555C66.8677 133.555 69.3263 131.093 69.3263 128.056C69.3263 125.02 66.8677 122.558 63.8348 122.558C60.8019 122.558 58.3433 125.02 58.3433 128.056C58.3433 131.093 60.8019 133.555 63.8348 133.555Z",
    fill: "#BBE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.552 99.4564H76.0907C75.5725 99.4564 75.1556 99.039 75.1556 98.5201V90.4449C75.1556 89.9261 75.5725 89.5086 76.0907 89.5086H156.546C157.064 89.5086 157.481 89.9261 157.481 90.4449V98.5201C157.481 99.039 157.064 99.4564 156.546 99.4564H156.552ZM63.8389 88.9838C60.8073 88.9838 58.3474 91.4469 58.3474 94.4825C58.3474 97.5182 60.8073 99.9813 63.8389 99.9813C66.8706 99.9813 69.3305 97.5182 69.3305 94.4825C69.3305 91.4469 66.8706 88.9838 63.8389 88.9838Z",
    fill: "url(#paint7_linear_4385_14334)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4385_14334",
    x: 36.92,
    y: 14.0124,
    width: 29.6556,
    height: 24.3494,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.55789,
    dy: 1.24631
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24631
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.572549 0 0 0 0 1 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4385_14334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4385_14334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4385_14334",
    x: 44.1137,
    y: 38.8738,
    width: 48.6599,
    height: 38.9724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.24631,
    dy: 2.8042
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24631
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.576471 0 0 0 0 0.968627 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4385_14334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4385_14334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4385_14334",
    x: 37.2427,
    y: 73.9732,
    width: 148.486,
    height: 85.3097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.57069,
    dy: 5.35603
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.35603
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.572549 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4385_14334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4385_14334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4385_14334",
    x1: 121.063,
    y1: 53.1545,
    x2: 120.198,
    y2: 179.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAFCFF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EDF6FF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D8EDFF",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BCE0FF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4385_14334",
    x1: 204.509,
    y1: 1.30886,
    x2: 203.802,
    y2: 73.0743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAFCFF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EDF6FF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D8EDFF",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BCE0FF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4385_14334",
    x1: 34.2059,
    y1: -0.369285,
    x2: 33.4985,
    y2: 71.3962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAFCFF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EDF6FF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D8EDFF",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BCE0FF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4385_14334",
    x1: 31.1683,
    y1: 80.8926,
    x2: 31.6231,
    y2: 135.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAFCFF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EDF6FF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D8EDFF",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BCE0FF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4385_14334",
    x1: 137.219,
    y1: 226.022,
    x2: 137.219,
    y2: 104.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4385_14334",
    x1: 34.4603,
    y1: 9.82111,
    x2: 55.9316,
    y2: 47.7462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0092E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4385_14334",
    x1: 39.3507,
    y1: 29.4175,
    x2: 76.3456,
    y2: 95.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0092E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4385_14334",
    x1: 23.7503,
    y1: 82.1523,
    x2: 30.1792,
    y2: 121.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0092E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0EEFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4385_14334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 134,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBotResult);
export default __webpack_public_path__ + "static/media/image_bot_result.fb9e6e8e9f8414df7c8d6c4d9b1baa18.svg";
export { ForwardRef as ReactComponent };